// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__rmJ1r","icon":"SortAdornment_icon__3h6q1","up":"SortAdornment_up__1qisD","down":"SortAdornment_down__2NxjD","active":"SortAdornment_active__55APt"};